import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'rebass/styled-components'

const Container = ({ children, width = 960, px = 3 }) => (
  <Box
    variant="container"
    sx={{
      maxWidth: width,
      px,
    }}
  >
    {children}
  </Box>
)

Container.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  px: PropTypes.number,
}

Container.defaultProps = {
  width: 960,
  px: 3,
}

export default Container
